import classes from './DiscoveryButtons.module.css';

function DiscoveryButtons({ buttons, onButtonClick, onBack }) {
  if (!Array.isArray(buttons) || buttons.length === 0) {
    return null;
  }

  return (
    <div className={classes.DiscoveryButtonsWrap}>
      {onBack ? (
        <button type="button" className={classes.DiscoveryBack} onClick={onBack}>
          חזרה
        </button>
      ) : null}
      <div className={classes.DiscoveryButtons}>
        {buttons.map((button, index) => (
          <div
            key={index}
            className={classes.DiscoveryButton}
            onClick={() => onButtonClick(button)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onButtonClick(button);
              }
            }}
          >
            {button.icon?.trim() ? (
              <img
                key={button.icon}
                src={button.icon}
                className={classes.DiscoveryIcon}
                alt=""
              />
            ) : null}
            <div style={{ width: '10px' }}></div>
            <div className={classes.DiscoveryText}>{button.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DiscoveryButtons;
